import type { Step } from '@/components/wizard/Step';

import {
  ConnectGcpRestoreAccount,
  type GcpConnectRestoreAccountState,
} from './connectGcpRestoreAccount';
import {
  ConnectGcpSourceAccount,
  type GcpConnectSourceAccountState,
} from './connectGcpSourceAccount';
import {
  ConnectGcpSourceFolder,
  type GcpConnectFolderState,
} from './connectGcpSourceFolder';
import {
  ConnectGcpSourceOrganization,
  type GcpConnectOrganizationState,
} from './connectGcpSourceOrganization';

export const gcpConnectSourceProjectFlow: Step<GcpConnectSourceAccountState> = {
  id: 'connect_gcp_source_project',
  Component: ConnectGcpSourceAccount,
  nonReturnable: false,
};

export const gcpConnectSourceFolderFlow: Step<GcpConnectFolderState> = {
  id: 'connect_gcp_source_folder',
  Component: ConnectGcpSourceFolder,
  nonReturnable: false,
};

export const gcpConnectSourceOrganizationFlow: Step<GcpConnectOrganizationState> =
  {
    id: 'connect_gcp_source_organization',
    Component: ConnectGcpSourceOrganization,
    nonReturnable: false,
  };

export const gcpConnectRestoreFlow: Step<GcpConnectRestoreAccountState> = {
  id: 'connect_gcp_restore',
  Component: ConnectGcpRestoreAccount,
  nonReturnable: false,
};
